<template>
  <div class="echartstest">
    <div :style="echarStyle" :id="echartId" :ref="echartRef"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
  props: {
    echartsdatas: {
      type: Object,
      default: () => {},
    },
    echarStyle: {
      type: Object,
      default: () => {},
    },
    echartId: {
      type: String,
      default: () => '',
    },
    echartRef: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      myChart: null,
    };
  },
  methods: {
    theEchart() {
      let echartsId = this.echartId;
      this.myChart = echarts.init(document.getElementById(echartsId));
      let option = this.echartsdatas;
      this.myChart.setOption(option);
    },
    setOption(option) {
      this.myChart.setOption(option);
    },
  },
  mounted() {
    this.theEchart();
  },
};
</script>

<style></style>
